import { useState, useCallback } from 'react';

/** Note: This should be used extremely rarely.
 * This forces the component in question to re-render.
 */
export const useForceRender = () => {
    const [, updateState] = useState({});
    const forceUpdate = useCallback(() => updateState({}), []);

    return forceUpdate;
};